module.exports = __webpack_public_path__ + "static/media/doom.36cb5331.jpg";